var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import styles from "../../styles/ResultGrid.module.scss";
var HEADERS = ['Color ID', 'Mana Value (CMC)', 'Initial Printing', 'Power + Toughness', 'Subtypes'];
var Headers = function () {
    return (_jsx("div", __assign({ className: styles.rowContainer }, { children: HEADERS.map(function (header) { return (_jsx("div", __assign({ className: styles.headerCell }, { children: header }), header)); }) }), void 0));
};
export default Headers;
